/* eslint-disable @typescript-eslint/no-unused-vars */

import { Auth } from 'aws-amplify'

// import { makeAuth } from '../../../factories'
// import { getUser } from '../../../utils/storage/user'
// import { settings } from '../../../../main/configs/settings'

export const sendMeTo = (userInfo: any, meta: any) => {
  return 'next'
  /* const { hasActiveSubscription, hasCustomerFolders, hasTrialSubscription, accessFreeContent } = userInfo

  if (meta.subscriptionIsNotRequired && hasCustomerFolders) return settings.dashboardRoute
  if ((hasActiveSubscription || hasTrialSubscription) && !hasCustomerFolders && meta.verifyActiveSubscritionAndNotHasAccess) return '/atualizar-cartao'
  if (meta.subscriptionIsNotRequired || hasCustomerFolders || accessFreeContent) return 'next'
  if (hasActiveSubscription || hasTrialSubscription) return '/atualizar-cartao'
  return '/planos' */
}

export const guardsRoutes = async (to: any, from: any, next: any) => {
  if (to.meta.auth) {
    try {
      const authenticate = await Auth.currentAuthenticatedUser()
      next()
      // console.log(authenticate)
    } catch (e) {
      console.log(e)
      next.redirect(`/login?redirect=${btoa(window.location.href)}`)
    }
  }
  next()
}
